export const REDUCE_SIDEBAR = "REDUCE_SIDEBAR";
export const REDUCE_MODAL_DATA = "REDUCE_MODAL_DATA";